import { Backdrop, Button, TableCell, tableCellClasses, TableRow, Stepper, DialogContent } from "@mui/material";
import styled, { css, keyframes } from "styled-components";
import { color } from "../../../shared/styles";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
    to {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
    padding: 32px 32px 24px 32px;
    max-width: 88vw;
    width: 76vw;
    min-width: 640px;
    max-height: 86vh;
    border-radius: 10px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: Noto Sans;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    animation: ${({ isOpen }) =>
        isOpen
            ? css`
                  ${fadeIn} 0.3s ease-out forwards
              `
            : css`
                  ${fadeOut} 0.3s ease-out forwards
              `};
`;

export const Expandable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: auto;
`;

export const TableWrapper = styled.div`
    overflow-y: auto;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const InfoText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

export const TitleText = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
`;

export const TitleTextList = styled.div`
    display: flex;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 15px;
    text-align: center;
`;

export const SummaryTableRow = styled(TableRow)`
    background-color: ${color.secondary.LIGHT_GREY};
    position: sticky;
    z-index: 10;
    bottom: 0;
`;

export const SummaryTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        color: "#0D0C0C",
        fontSize: "14px",
        fontWeight: "700",
        lineHeight: "42px",
        wordWrap: "break-word",
        padding: "8px 8px 8px 8px",
        width: "171px",
        minWidth: "171px",
        fontFamily: "Noto Sans",
        whiteSpace: "nowrap",
    },
}));

export const ButtonRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 16px;
    padding-bottom: 8px;
    margin-top: auto;
`;

export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 14px;
        padding-right: 14px;
        display: flex;
        justify-content: space-between;
        gap: 6px;
        font-size: 14px;
        height: 36px;
        border-radius: 5px;
        width: auto;
    }
`;

export const StyledBackdrop = styled(Backdrop)`
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
`;

export const StepperStyled = styled(Stepper)`
    margin-top: 4px;
    margin-bottom: 20px;
    & .MuiStepLabel-label {
        font-size: 16px;
        font-weight: 600;
        font-family: Noto Sans;
    }
    & .MuiStepLabel-root {
        padding-top: 2px;
        padding-bottom: 2px;
    }
    & .MuiStepLabel-labelContainer {
        padding-top: 2px;
    }
`;

export const DialogHeader = styled.div`
    margin-top: 4px;
    margin-bottom: 8px;
`;

export const DialogContentSpacious = styled(DialogContent)`
    padding: 24px 32px 24px 32px;
    font-family: Noto Sans;
`;

export const ModalTitle = styled.div`
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    color: ${color.secondary.CHARCOAL};
    font-family: Noto Sans;
    margin: 2px 0 18px 0;
`;
